// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  analytics: {
    id: 'UA-23399050-10'
  },
  firebase: {
    apiKey: 'AIzaSyBOahac1sWn_vcmdfMoqKvYnAAeYQeZCTA',
    authDomain: 'career-e209d.firebaseapp.com',
    databaseURL: 'https://career-e209d.firebaseio.com',
    projectId: 'career-e209d',
    storageBucket: 'career-e209d.appspot.com',
    messagingSenderId: '452866610830'
  },
  baseUrl: 'https://career.firebaseapp.com',
  AlgoliaAppId: 'C77235ICBN',
  AlgoliaApiKey: '83cb9ddcb726d86f725454020a0fd4c4',
  AlgoliaIndexPrefix: 'dev'
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
